'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Immutable from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import Routes from 'ContentUtils/Routes';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { ContentCategories } from 'FileManagerCore/Constants';
import FileUsageTypes from '../enums/FileUsageTypes';
import { getEditableUsage } from '../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
function i18nKey(suffix) {
  return `FileManagerDashboard.fileUsage.${suffix}`;
}
export default class FileUsage extends Component {
  constructor(...args) {
    super(...args);
    this.renderItem = item => {
      const url = this.getUrl(item);
      return /*#__PURE__*/_jsx("span", {
        children: url && /*#__PURE__*/_jsx(UILink, {
          href: url,
          external: true,
          children: item.get('label')
        })
      }, item.get('id'));
    };
    this.renderResourceType = (items, type) => {
      return /*#__PURE__*/_jsx(UIAccordionItem, {
        className: "m-top-4",
        contentClassName: "m-top-4",
        title: I18n.text(i18nKey(`resourceTypes.${type}`), {
          count: items.count()
        }),
        children: /*#__PURE__*/_jsx(UIList, {
          childClassName: "m-bottom-1",
          children: items.map(this.renderItem).toArray()
        })
      }, type);
    };
  }
  getUrl(item) {
    const id = item.get('id');
    switch (item.get('type')) {
      case FileUsageTypes.CONTENT:
        return Routes.edit(id, ContentCategories.get(item.get('subType')));
      case FileUsageTypes.EXTENSION_RESOURCE:
        return Routes.designManager(id, DesignAssetTypes.TEMPLATE);
      case FileUsageTypes.LAYOUT:
        {
          return Routes.designManager(id, DesignAssetTypes.LAYOUT);
        }
      case FileUsageTypes.CUSTOM_WIDGET:
        {
          return Routes.designManager(id, DesignAssetTypes.CUSTOM_WIDGET);
        }
      default:
        return null;
    }
  }
  renderFileNotUsedMessage() {
    const {
      forDeleteModal
    } = this.props;
    let key = 'unused';
    if (forDeleteModal) {
      key = 'unusedForTrashModal';
    }
    return /*#__PURE__*/_jsx("p", {
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(key)
      })
    });
  }
  renderItems() {
    const {
      usage
    } = this.props;
    if (usage.get('items').size) {
      return usage.get('items').filter(getEditableUsage).map(this.renderResourceType).toArray();
    }
    return this.renderFileNotUsedMessage();
  }
  renderRequestFailedMessage() {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('requestFailure')
      })
    });
  }
  render() {
    const {
      hasRequestFailed
    } = this.props;
    if (hasRequestFailed) {
      this.renderRequestFailedMessage();
    }
    return this.renderItems();
  }
}
FileUsage.propTypes = {
  usage: PropTypes.instanceOf(Immutable.Map).isRequired,
  hasRequestFailed: PropTypes.bool.isRequired,
  forDeleteModal: PropTypes.bool.isRequired
};
FileUsage.defaultProps = {
  forDeleteModal: false
};